module.exports = __webpack_public_path__ + "static/m650-ec7fa6e75dad3133d0d7817b49e9e748.png";